import { Box } from "@chakra-ui/react";

import Navbar from "./organisam/Navbar";
import AllRoutes from "./Pages/AllRoutes";
import Footer from "./organisam/Footer";

function App() {
  return (
    <Box>
      {/* <Navbar /> */}
      <AllRoutes />
      {/* <Footer /> */}
    </Box>
  );
}

export default App;
